import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAddAnswerMutation, AnswerType } from '@/store/quizApi';
import { tg } from '@/constants/telegram';
import styles from './TestimonialsPage.module.scss';

import testimonial6Video from '@/assets/testimonials/6.mp4';
import testimonial7Video from '@/assets/testimonials/7.mp4';
import testimonial8Video from '@/assets/testimonials/8.mp4';
import testimonial9Video from '@/assets/testimonials/9.mp4';
import testimonial10Video from '@/assets/testimonials/10.mp4';

import testimonial1Image from '@/assets/testimonials/1.jpg';
import testimonial2Image from '@/assets/testimonials/2.jpg';
import testimonial3Image from '@/assets/testimonials/3.jpg';
import testimonial4Image from '@/assets/testimonials/4.jpg';
import testimonial5Image from '@/assets/testimonials/5.jpg';

const testimonialsData = [
  {
    id: 1,
    type: 'video',
    video: testimonial6Video, // файл 6 - парень
    text: `Ну что сказать — ИИ‑тренер это просто бомба! Сначала не верила: как комп меня тренировать будет? А оказалось — всё чётко. План под меня, видео показывают как делать, в чате отвечают моментально. За 3 месяца: сбросила 5 кг, талия уменьшилась на 4 см, подтянулись бёдра и руки. Раньше сама тренировалась — толку ноль, а тут реальный прогресс! Рекомендую, штука рабочая!`
  },
  {
    id: 2,
    type: 'video',
    video: testimonial7Video, // файл 7 - парень
    text: `Попробовала ИИ‑тренера — и осталась в восторге!
Плюсы:
• план идеально подошёл под мой график;
• видео помогают выполнять упражнения правильно;
• в чате всегда оперативно отвечают.
За 3 месяца:
• сбросила 6 кг;
• бёдра уменьшились на 4 см;
• подтянула мышцы рук и пресса.
Тренировки теперь приносят удовольствие — спасибо за отличный сервис!`
  },
  {
    id: 3,
    type: 'video',
    video: testimonial8Video, // файл 8 - девушка
    text: `ИИ‑тренер стал моим спасением! Как работающая мама, я наконец нашла способ поддерживать форму без походов в зал.
Главные плюсы:
• индивидуальный план под мой график;
• понятные видео‑инструкции;
• поддержка в чате 24/7.
За 4 месяца:
• сбросила 8 кг;
• талия уменьшилась на 5 см;
• подтянулись бёдра и руки.
Чувствую себя энергичнее и увереннее. Рекомендую всем занятым женщинам!`
  },
  {
    id: 4,
    type: 'video',
    video: testimonial9Video, // файл 9 - парень
    text: `Решила попробовать ИИ‑тренера из любопытства — и не пожалела! Теперь это мой главный помощник в фитнесе.
Преимущества:
• программа подстраивается под мои результаты;
• детальные инструкции по каждому упражнению;
• быстрая обратная связь в чате.
За 4 месяца:
• сбросила 5 кг;
• талия уменьшилась на 4 см;
• выносливость увеличилась в 2 раза.
Теперь тренируюсь регулярно и вижу реальный прогресс!`
  },
  {
    id: 5,
    type: 'video',
    video: testimonial10Video, // файл 10 - парень
    text: `ИИ‑тренер стал отличным решением для эффективных тренировок!
Особенно понравились:
• персонализированный план с учётом моих целей и уровня подготовки;
• видео‑инструкции к упражнениям;
• круглосуточная поддержка в чате.
Итоги за 2 месяца:
• вес снизился на 5 кг;
• объём талии уменьшился на 3 см;
• силовые показатели выросли на 20 %.
Рекомендую всем, кто хочет тренироваться с комфортом!`
  },
  // Фото отзывы
  {
    id: 6,
    type: 'image',
    image: testimonial1Image, // файл 1 - девушка
    text: `Изначально сомневался в эффективности виртуального тренера, но ИИ‑тренер удивил!
Что ценно:
• точные настройки под мои особенности;
• актуальные планы с учётом прогресса;
• мгновенные ответы в чате.
Результаты за полгода:
• мышечная масса увеличилась на 4 кг;
• процент жира снизился с 18 % до 12 %;
• кардио‑выносливость улучшилась на 30 %.
Отличный инструмент для достижения фитнес‑целей. Рекомендую!`
  },
  {
    id: 7,
    type: 'image',
    image: testimonial2Image, // файл 2 - девушка
    text: `ИИ‑тренер стал отличным решением для эффективных тренировок!
Особенно понравились:
• персонализированный план с учётом моих целей и уровня подготовки;
• видео‑инструкции к упражнениям;
• круглосуточная поддержка в чате.
Итоги за 2 месяца:
• вес снизился на 5 кг;
• объём талии уменьшился на 3 см;
• силовые показатели выросли на 20 %.
Рекомендую всем, кто хочет тренироваться с комфортом!`
  },
  {
    id: 8,
    type: 'image',
    image: testimonial3Image, // файл 3 - девушка
    text: `ИИ‑тренер изменил моё отношение к тренировкам! Раньше не могла найти мотивацию, а теперь с нетерпением жду каждую тренировку.
Преимущества:
• персональный подход без личного тренера;
• удобный формат занятий дома;
• постоянная поддержка и мотивация.
За 5 месяцев:
• сбросила 7 кг;
• подтянула проблемные зоны;
• обрела уверенность в себе.
Это лучшая инвестиция в своё здоровье и красоту!`
  },
  {
    id: 9,
    type: 'image',
    image: testimonial4Image, // файл 4 - девушка
    text: `Долго искал способ накачать мышцы без походов в зал. ИИ‑тренер оказался именно тем, что нужно!
Что понравилось:
• программа для набора массы;
• детальные инструкции по технике;
• поддержка в чате 24/7.
За 5 месяцев:
• набрал 7 кг мышечной массы;
• жим лёжа вырос с 60 до 90 кг;
• объём бицепса увеличился на 3 см.
Теперь у меня тело, о котором я мечтал!`
  },
  {
    id: 10,
    type: 'image',
    image: testimonial5Image, // файл 5 - девушка
    text: `Хотел похудеть и подкачаться, но не знал с чего начать. ИИ‑тренер составил идеальный план!
Преимущества:
• программа для похудения и набора мышечной массы;
• понятные видео с техникой выполнения;
• быстрые ответы на все вопросы.
За 4 месяца:
• сбросил 8 кг жира;
• набрал 3 кг мышц;
• стал сильнее и выносливее.
Результат превзошёл все ожидания!`
  }
];

export const TestimonialsPage: React.FC = () => {
  const navigate = useNavigate();
  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [quizAnswer] = useAddAnswerMutation();
  const hasMarkedAsViewed = useRef(false);

  const currentData = testimonialsData[currentTestimonial];

  // Отмечаем отзывы как просмотренные при уходе со страницы
  const markAsViewed = useCallback(async () => {
    if (hasMarkedAsViewed.current || !tg?.initData) {
      return;
    }

    hasMarkedAsViewed.current = true;

    try {
      await quizAnswer({
        question_id: 2001,
        answer: 'next',
        answer_type: AnswerType.ONE_BUTTON
      }).unwrap();
    } catch (error) {
      console.error('Ошибка при отправке ответа:', error);
      // Не показываем ошибку пользователю, так как это не критично
    }
  }, [quizAnswer]);

  useEffect(() => {
    // Отмечаем как просмотренные при размонтировании компонента
    return () => {
      markAsViewed();
    };
  }, [markAsViewed]);

  const handlePrevious = () => {
    setCurrentTestimonial((prev) => 
      prev === 0 ? testimonialsData.length - 1 : prev - 1
    );
  };

  const handleNext = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonialsData.length);
  };

  const handleDotClick = (index: number) => {
    setCurrentTestimonial(index);
  };

  const handleBack = async () => {
    await markAsViewed();
    navigate(-1);
  };

  const handleToProgram = async () => {
    await markAsViewed();
    navigate('/trains');
  };

  if (!currentData) {
    return <div className={styles.container}>Загрузка...</div>;
  }

  return (
    <div className={styles.container}>
      {/* Header */}
      <div className={styles.header}>
        <button className={styles.backButton} onClick={handleBack}>
          ← Назад
        </button>
      </div>

      <h1 className={styles.title}>Отзывы наших клиентов</h1>

      {/* Testimonial Card */}
      <div className={styles.testimonialCard}>
        <div className={styles.mediaContainer}>
          {currentData.type === 'video' && currentData.video ? (
            <div className={styles.videoWrapper}>
              <video
                src={currentData.video}
                controls
                className={styles.video}
                playsInline
              />
            </div>
          ) : currentData.type === 'image' && currentData.image ? (
            <div className={styles.imageWrapper}>
              <img 
                src={currentData.image} 
                alt={`Отзыв ${currentData.id}`}
                className={styles.image}
              />
            </div>
          ) : null}
          
          {/* Navigation Arrows */}
          <button 
            className={`${styles.navButton} ${styles.navButtonLeft}`}
            onClick={handlePrevious}
            aria-label="Предыдущий отзыв"
          >
            ‹
          </button>
          <button 
            className={`${styles.navButton} ${styles.navButtonRight}`}
            onClick={handleNext}
            aria-label="Следующий отзыв"
          >
            ›
          </button>
        </div>
        
        {/* Testimonial Text */}
        <div className={styles.textContainer}>
          <div className={styles.testimonialNumber}>
            Отзыв {currentTestimonial + 1}
          </div>
          <p className={styles.testimonialText}>
            {currentData.text}
          </p>
        </div>
      </div>

      {/* Pagination Dots */}
      <div className={styles.pagination}>
        {testimonialsData.map((_, index) => (
          <button
            key={index}
            className={`${styles.dot} ${index === currentTestimonial ? styles.activeDot : ''}`}
            onClick={() => handleDotClick(index)}
            aria-label={`Перейти к отзыву ${index + 1}`}
          />
        ))}
      </div>

      {/* Кнопка к программе */}
      <div className={styles.bottomButtonContainer}>
        <button className={styles.toProgramButton} onClick={handleToProgram}>
          К программе
        </button>
      </div>
    </div>
  );
};
